import { UserCheck, Eye, Award, Zap } from "lucide-react";

const icons = [UserCheck, Eye, Award, Zap];

export const WhyUs = ({ t }) => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-zinc-900/40 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="overline">{t.why.overline}</span>
          <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
            {t.why.title}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800">
          {t.why.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div
                key={item.title}
                data-testid={`why-item-${i}`}
                className="bg-zinc-950 p-8 md:p-10 hover:bg-zinc-900 transition-colors group"
              >
                <div className="flex items-center gap-4 mb-8">
                  <Icon
                    className="w-7 h-7 text-red-600 group-hover:scale-110 transition-transform"
                    strokeWidth={1.8}
                  />
                  <span className="font-body text-xs font-bold tracking-[0.25em] uppercase text-zinc-600">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold tracking-tight text-zinc-50">
                  {item.title}
                </h3>
                <p className="font-body mt-3 text-sm text-zinc-400 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
